import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteZeitUnterartCommandComponent } from '.';
import { DeleteZeitUnterartCommandServiceModule } from '..';

@NgModule({
  imports: [
    LIB_CommonModule,
    DeleteZeitUnterartCommandServiceModule
  ],
  declarations: [DeleteZeitUnterartCommandComponent],
  exports: [DeleteZeitUnterartCommandComponent],

})
export class DeleteZeitUnterartCommandComponentModule { }
